'use client'

import Link from 'next/link'
import { useTranslation } from '@/lib/i18n'
import { richText } from '@/components/user-portal/learner-i18n'

/**
 * The player portal's footer. The layout is a server component, so the part
 * that speaks the learner's language lives here (locale audit 2026-09-26).
 */
export function PlayerFooter() {
  const { t } = useTranslation()
  return (
    <footer className="border-t py-4 text-center text-xs text-muted-foreground">
      <div className="mx-auto max-w-7xl px-4">
        {richText(t('play.footer.poweredBy'), {
          link: (
            <Link href="/play/framework" className="underline hover:text-foreground">
              {t('play.footer.learnMore')}
            </Link>
          ),
        })}
      </div>
    </footer>
  )
}

/** "Loading…" in the learner's language, for fallbacks rendered by server pages. */
export function PlayLoading({ className }: { className?: string }) {
  const { t } = useTranslation()
  return <p className={className}>{t('play.loading')}</p>
}
